export const categories = {
    layout: {
        listTitle: 'Categorias',
        newTitle: 'Nova Categoria',
        editTitle: 'Editar Categoria',
    },
    list: {
        expensesTab: 'Despesas',
        incomeTab: 'Receitas',
        subcategoryCount_one: '{{count}} subcategoria',
        subcategoryCount_other: '{{count}} subcategorias',
        emptyTitle: 'Nenhuma categoria',
        emptySubtitle: 'Adicione uma nova categoria',
        emptyAction: 'Adicionar',
    },
    form: {
        nameLabel: 'Nome da categoria',
        namePlaceholder: 'Ex: Alimentação',
        typeLabel: 'Tipo',
        typeExpense: 'Despesa',
        typeIncome: 'Receita',
        colorLabel: 'Cor',
        iconLabel: 'Ícone',
        subcategoriesLabel: 'Subcategorias',
        cancelEditAccessibility: 'Cancelar edição',
        saveSubcategoryAccessibility: 'Salvar subcategoria',
        editSubcategoryAccessibility: 'Editar subcategoria {{name}}',
        renameSubcategoryAccessibility: 'Renomear {{name}}',
        removeSubcategoryAccessibility: 'Remover {{name}}',
        reorderSubcategoriesAccessibility: 'Reordenar subcategorias',
        saveSubcategoryOrderAccessibility: 'Salvar ordem das subcategorias',
        moveSubcategoryUpAccessibility: 'Mover {{name}} para cima',
        moveSubcategoryDownAccessibility: 'Mover {{name}} para baixo',
        newSubcategoryPlaceholder: 'Nova subcategoria...',
        archiveAction: 'Arquivar categoria',
        unarchiveAction: 'Desarquivar categoria',
        mergeAction: 'Mesclar com outra categoria',
        deleteAction: 'Apagar categoria',
        moreOptionsAccessibility: 'Mais opções da categoria',
        createAccessibility: 'Criar categoria',
        saveAccessibility: 'Salvar',
        colorSheetTitle: 'Escolha uma cor',
        iconSheetTitle: 'Escolha um ícone',
    },
    archiveDialog: {
        archiveTitle: 'Arquivar categoria',
        unarchiveTitle: 'Desarquivar categoria',
        archiveMessage: 'A categoria será ocultada, mas as transações existentes serão mantidas.',
        unarchiveMessage: 'A categoria voltará a aparecer nas listagens.',
        archiveConfirm: 'Arquivar',
        unarchiveConfirm: 'Desarquivar',
    },
    deleteDialog: {
        title: 'Apagar categoria',
        // {{txCount}} em vez de {{count}} de propósito: o "(s)" é literal no texto de
        // hoje — count ativaria o plural do i18next e mudaria a mensagem.
        messageWithTransactions: '"{{name}}" tem {{txCount}} lançamento(s). Ao apagar, eles serão movidos para "{{fallbackName}}". Esta ação não pode ser desfeita.',
        message: 'Apagar "{{name}}"? Esta ação não pode ser desfeita.',
        confirm: 'Apagar',
    },
    mergeDialog: {
        title: 'Mesclar categoria',
        message: 'Todas as transações e subcategorias desta categoria serão movidas para a categoria destino. Esta ação não pode ser desfeita.',
        confirm: 'Escolher destino',
    },
    mergeSuccessDialog: {
        title: 'Mesclado',
        message: '{{txCount}} transação(ões) movida(s) para a categoria destino.',
        confirm: 'OK',
    },
    deleteSubcategoryDialog: {
        title: 'Remover subcategoria',
        message: 'Remover "{{name}}"? As transações vinculadas ficarão sem subcategoria.',
        confirm: 'Remover',
    },
    selector: {
        expenseTitle: 'Categorias de Despesa',
        incomeTitle: 'Categorias de Receita',
        searchPlaceholder: 'Buscar categoria...',
        noSubcategory: 'Sem subcategoria',
        openCategory: 'Ver subcategorias de {{name}}',
        emptySubcategoriesHint: 'Nenhuma subcategoria ainda. Toque em + para criar a primeira.',
        newSubcategoryPlaceholder: 'Nome da subcategoria',
        deleteSubcategoryTitle: 'Remover subcategoria',
        deleteSubcategoryMessage: 'Remover "{{name}}"? Transações vinculadas ficarão sem subcategoria.',
        cancelButton: 'Cancelar',
        removeButton: 'Remover',
    },
};
